export default __webpack_public_path__ + "static/media/leftPeople.c5632f6c.png";